import Auth from "@/app/plugins/Auth";

export function guards (to, from, next) {

  if (to.meta.public) {
    next();
    return false;
  }

  if (!Auth.check()) {
    next({ name: 'Login' });
    return false;
  }

  if (!to.meta?.permissao) {
    next();
    return false;
  }

  Auth.can(to.meta.permissao) ? next() : next({ name: 'Home' });

  // next();

}
